import { useTranslation } from 'react-i18next';
import { S, Icon, formatDate } from '../regureStyles';
import SignerAvatars from './SignerAvatars';
import StatusBadge from './StatusBadge';

const Table = ({ requests, history }) => {
  const { t } = useTranslation();
  const headers = [
    t('screens.esign.colDocument'),
    t('screens.esign.colSigners'),
    t('screens.esign.colStatus'),
    t('screens.esign.colCreated'),
    t('screens.esign.colExpires'),
    '',
  ];
  return (
    <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 16, overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: S.bgCard, borderBottom: `1px solid ${S.borderLight}` }}>
            {headers.map((h, i) => (
              <th
                key={i}
                style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontSize: 11,
                  fontWeight: 700,
                  color: S.textMuted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.8,
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {requests.map((req, i) => (
            <tr
              key={req._id}
              onClick={() => history.push(`/e-signatures/${req._id}`)}
              style={{
                borderBottom: i < requests.length - 1 ? `1px solid ${S.borderLight}` : 'none',
                cursor: 'pointer',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => (e.currentTarget.style.background = S.bgHover)}
              onMouseLeave={e => (e.currentTarget.style.background = '#fff')}
            >
              <td style={{ padding: '14px 16px' }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: S.textPrimary }}>{req.title}</div>
                {req.document?.fileName && <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{req.document.fileName}</div>}
              </td>
              <td style={{ padding: '14px 16px' }}>
                <SignerAvatars signers={req.signers} />
              </td>
              <td style={{ padding: '14px 16px' }}>
                <StatusBadge status={req.status} />
              </td>
              <td style={{ padding: '14px 16px', fontSize: 13, color: S.textSecondary }}>
                {req.createdAt ? formatDate(req.createdAt) : '—'}
              </td>
              <td style={{ padding: '14px 16px', fontSize: 13, color: req.expiresAt && new Date(req.expiresAt) < new Date() ? '#ef4444' : S.textSecondary }}>
                {req.expiresAt ? formatDate(req.expiresAt) : '—'}
              </td>
              <td style={{ padding: '14px 16px' }}>
                <Icon name='chevronRight' color={S.textMuted} size={16} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
